<div>Sensor Component</div>


